module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"from":"from","to":"to","notProvided":"not provided","year":"per year","month":"per month","week":"per week","day":"per day","hour":"per hour","net":"net","gross":"gross"}}')
  delete Component.options._Ctor
}
